/* eslint-disable no-shadow */
import vars from '../helpers';

function init() {
	let $slider = $('.js-slider');

	if ($slider.length) {
		$slider.each((index, slider) => {
			let $slider = $(slider);
			let $sliderPrev = $slider.closest('.slider').find('.js-slider-prev');
			let $sliderNext = $slider.closest('.slider').find('.js-slider-next');

			$slider.on('init', (event) => {
				vars.$document.trigger('slider-init', event.target);
			});

			$slider.slick({
				infinite: true,
				slidesToShow: 1, // 3
				slidesToScroll: 1,
				variableWidth: true,
				prevArrow: $sliderPrev,
				nextArrow: $sliderNext,
				responsive: [
					{
						breakpoint: 1024,
						settings: {
							// slidesToShow: 1,
							// slidesToScroll: 1,
							variableWidth: false,
						},
					},
				],
			});

			$slider.on('afterChange', () => {
				vars.$document.trigger('slider-change');
			});
		});
	}
}

export default {
	init,
};
